/**
 * Slice Components Registry
 *
 * Exports all slice components for use with Prismic's SliceZone.
 * Keys must match slice type names defined in Prismic custom types.
 */

import { Hero } from "./Hero";
import { Intro } from "./Intro";
import { About } from "./About";
import { Brands } from "./Brands";
import { FeaturedVideo } from "./FeaturedVideo";
import { Partners } from "./Partners";
import { Collabs } from "./Collabs";
import { Contact } from "./Contact";
import { Showcase } from "./Showcase";
import { SwiperSlider } from "./SwiperSlider";
import { Global } from "./Global";
import { Careers } from "./Careers";
import { TextBlock } from "./TextBlock";
import { Testimonials } from "./Testimonials";

/**
 * Components map for SliceZone
 * Keys are slice API IDs (snake_case), values are React components
 */
export const components = {
  hero: Hero,
  intro: Intro,
  about: About,
  brands: Brands,
  featured_video: FeaturedVideo,
  partners: Partners,
  social_videos: Collabs,
  contact: Contact,
  showcase: Showcase,
  swiper_slider: SwiperSlider,
  global: Global,
  careers: Careers,
  text_block: TextBlock,
  testimonials: Testimonials,
};
